import styled from 'styled-components';
import UIImage from 'UIComponents/image/UIImage';
import imageUrls from '../images/imageUrls';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const HubSpotAcademy = styled(UIImage).withConfig({
  displayName: "AcademyLogo__HubSpotAcademy",
  componentId: "sc-1ipkfct-0"
})(["display:inline-block;width:13rem;"]);
export const getAcademyLogoConfig = isMobile => {
  const url = isMobile ? null : imageUrls.academyLogo;
  return {
    url,
    altText: 'HubSpot Academy',
    width: 220
  };
};
export const AcademyLogo = () => {
  const {
    isMobile
  } = useResponsiveness();
  const {
    url,
    altText
  } = getAcademyLogoConfig(isMobile);
  if (isMobile) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(HubSpotAcademy, {
      alt: altText,
      height: 40,
      responsive: false,
      src: url
    })
  });
};